import React, { Context, createContext } from "react";

const defaultContext = {};

const SiteContext = createContext(defaultContext);

export { SiteContext, defaultContext };
